import React from 'react';
import { Box, EmptyServicesListIcon, Inscription, Preloader, Text } from '@common-fe/common-fe';

import { SpendLimitsModal } from './SpendLimitsModal/SpendLimitsModal';
import CategoryItem from './CategoryItem';
import ControlPanel from './ControlPanel';
import { useCategoryActions, useEligibleServicesActions } from './hooks';
import TableHeaderWrapper from './TableHeaderWrapper';

interface Props {
  isEditMode?: boolean;
  isTemplateMode?: boolean;
  isPlanActive?: boolean;
}

const EligibleServices: React.FC<Props> = ({
  isEditMode,
  isTemplateMode,
  isPlanActive,
}) => {
  const { 
    sortParams,
    sortOptions,
    searchString,
    setSearchString,
    setSortParams,
    serviceTypeParamsValues,
    setServiceType,
    categoriesParamsValues,
    setCategories,
    total,
    isLoading,
    formattedData,
    parentId,
    perCategorySpendLimit,
  } = useEligibleServicesActions();

  const {
    expandedCategoryIdArray,
    categoryIdArray,
    indeterminateCategoryIdArray,
    handleSetExpandedCategory,
    handleCategorySelect,
  } = useCategoryActions(formattedData);

  return (
    <Box
      background={{ color: 'module' }}
      round="container1Round"
    >
      <Box align="center">
        <Box
          width="100%"
          direction="row"
          justify="between"
          align="center"
        >
          <Inscription
            weight="bold"
            color="textBody"
            style={{ whiteSpace: 'nowrap' }}
            lineHeight="20px"
          >
            Services: {total}
          </Inscription>
          <ControlPanel
            sortParams={sortParams}
            sortOptions={sortOptions}
            searchString={searchString}
            setSearchString={setSearchString}
            setSortParams={setSortParams}
            serviceTypeParamsValues={serviceTypeParamsValues}
            setServiceType={setServiceType}
            categoriesParamsValues={categoriesParamsValues}
            setCategories={setCategories}
            isPerCategorySpendLimit={perCategorySpendLimit}
            isEditMode={isEditMode}
          />
        </Box>
        {
          !formattedData?.length && !isLoading ? (
            <Box align="center" margin={{ top: 'l' }}>
              <EmptyServicesListIcon />
              <Text weight="bold" margin={{ top: 'spacing24' }} color="textBody" size="large">
                There are no Services
              </Text>
            </Box>
          ) : (
            <>
              <TableHeaderWrapper>
                <Box width={parentId ? '4%' : '8%'} />
                <Box width={parentId ? '48%' : (perCategorySpendLimit ? '35%' : '45%')}><Inscription size="12px" weight="bold">Service category</Inscription></Box>
                <Box width={parentId ? '48%' : (perCategorySpendLimit ? '30%' : '47%')}><Inscription size="12px" weight="bold">Number of services</Inscription></Box>
                {perCategorySpendLimit ? (
                  <Box width={parentId ? '48%' : '27%'}><Inscription size="12px" weight="bold">Spend Limit</Inscription></Box>
                ) : null}
              </TableHeaderWrapper>
              {isLoading ? (<Box height="62px" justify="center"><Preloader /></Box>) : (
                <Box width="100%" gap="xxs">
                  {formattedData?.map((data) => (
                    <CategoryItem
                      key={data?.id}
                      data={data}
                      isExpanded={expandedCategoryIdArray.includes(data?.id)}
                      isChecked={categoryIdArray.includes(data?.id)}
                      parentId={parentId}
                      isIndeterminate={indeterminateCategoryIdArray.includes(data?.id)}
                      onExpandCategoryId={handleSetExpandedCategory}
                      onSelect={handleCategorySelect}
                      isEditMode={isEditMode}
                      isTemplateMode={isTemplateMode}
                      isPlanActive={isPlanActive}
                      isPerCategorySpendLimit={perCategorySpendLimit}
                    />
                  ))}
                </Box>
              )}
            </>
          )
        }
      </Box>
      <SpendLimitsModal />
    </Box>
  );
};

export default EligibleServices;
